import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsRToV: readonly IndexedPublicationsSection[] = [
  {
    letter: 'R',
    references: [
      '@bib{BE_A_17_1};',
      '@bib{BE_D_5_2};',
      '@bib{BE_A_29_1};',
      '@bib{BE_A_30_1}; ',
      '@bib{NABU1997-138};',
      '@bib{RN2817aaxg};',
      '@bib{BE_A_6_1};',
      '@bib{RN1971ax}; ',
      '@bib{RN1971axx};',
      '@bib{Reade1986Foundation};',
      '@bib{Reade1987Babylonian};',
      '@bib{Reade1987Shamshi-ilu};',
      '@bib{CDLB2024-4};',
      '@bib{OECT_16};',
      '@bib{RN986a};',
      '@bib{RN2016};',
      '@bib{RN2064};',
      '@bib{reiner2005commentaries};',
      '@bib{reiner2005documents}; ',
      '@bib{reiner2005medical};',
      '@bib{RN2023aab};',
      '@bib{RN2845};',
      '@bib{RN1876}; ',
      '@bib{RN286};',
      '@bib{RN3157};',
      '@bib{RN3085};',
      '@bib{Reisner1901TUT};',
      '@bib{Renaut2003JMC2};',
      '@bib{Renzi-Sepe2023Pleiades};',
      '@bib{RN2769a}; ',
      '@bib{reynolds_2019};',
      '@bib{Richardson2002Ewe};',
      '@bib{deRidder2023Ludlul};',
      '@bib{deridder2025nocturnal};',
      '@bib{YOS_23};',
      '@bib{RN1543};',
      '@bib{Roaf2017Kassite};',
      '@bib{robson2004mathematical};',
      '@bib{RN275};',
      '@bib{rochberg1998babylonian}; ',
      '@bib{fromebllab0021};',
      '@bib{fromebllab0029};',
      '@bib{fromebllab0037};',
      '@bib{fromebllab0046};',
      '@bib{Ryskamp1976Foreword}',
    ],
  },
  {
    letter: 'S',
    references: [
      '@bib{Saadoon2024Lost};',
      '@bib{saadoon2024some};',
      '@bib{RN1773};',
      '@bib{RN1536};',
      '@bib{RN808};',
      '@bib{RN808xy};',
      '@bib{RN2280};',
      '@bib{RN2814};',
      '@bib{NABU2003-39};',
      '@bib{Sallaberger2024Coronation};',
      '@bib{RN2376};',
      '@bib{sandowicz2019dubsar};',
      '@bib{sarkisian1974new};',
      '@bib{sarkisian1978bruchstuecke};',
      '@bib{scarpelli2024wetter};',
      '@bib{schaudig_2020_Staatsrituale}; ',
      '@bib{Schaudig2023FSMaul};',
      '@bib{Schlossman1976Two};',
      '@bib{temp_id_11313936447857387};',
      '@bib{schmidtchen2025neues};',
      '@bib{schneider1930geschaeftsurkunden};',
      '@bib{Schneider1932Drehem};',
      '@bib{Schneider2023Context};',
      '@bib{SchollGR};',
      '@bib{RN522};',
      '@bib{RN521};',
      '@bib{RN569a};',
      '@bib{VS_11};',
      '@bib{VS_15};',
      '@bib{VS_16};',
      '@bib{schroeder1920keilschrifttexte};',
      '@bib{RN519};',
      '@bib{RN510}; ',
      '@bib{RN1354};',
      '@bib{RN518a};',
      '@bib{Schwemer2022Maqlu};',
      '@bib{Schwemer2022CMAwR};',
      '@bib{Scurlock2003JMC2};',
      '@bib{RN541};',
      '@bib{Seidl2017Babylonische};',
      '@bib{UET_6_3};',
      '@bib{Shelley2017Kaššû};',
      '@bib{RN1287};',
      '@bib{Shibata2023FSMaul};',
      '@bib{sigrist1988brick};',
      '@bib{sigrist1988cone}; ',
      '@bib{sigrist1988oldbabylonian};',
      '@bib{sigrist1988uriii};',
      '@bib{BPOA6};',
      '@bib{BPOA7};',
      '@bib{YOS_14};',
      '@bib{LS264};',
      '@bib{slotsky2009tallies};',
      '@bib{RN1971aaax}; ',
      '@bib{RN1971aaa};',
      '@bib{CT0037};',
      '@bib{smith1925babylonian};',
      '@bib{YOS_18};',
      '@bib{RN1582a};',
      '@bib{AbB_12};',
      '@bib{AbB_13}; ',
      '@bib{RN566};',
      '@bib{UET_8};',
      '@bib{LS323};',
      '@bib{CT0050};',
      '@bib{Sollberger1980Cuneiform};',
      '@bib{sollberger1988oldakkadian};',
      '@bib{Nisaba_12};',
      '@bib{spada2018sumerian};',
      '@bib{Spada2023Antichretic};',
      '@bib{Spada2023Duties};',
      '@bib{Spada2023Temple};',
      '@bib{spar1988ctmma1};',
      '@bib{spar2000ctmma3};',
      '@bib{RN829};',
      '@bib{spar2014ctmma4}; ',
      '@bib{vanderspek1998cuneiform};',
      '@bib{vanderspek2025babylonian};',
      '@bib{RN615};',
      '@bib{starr2005documents};',
      '@bib{steele2015late};',
      '@bib{steele2017text};',
      '@bib{steele2017mysterious};',
      '@bib{Steinkeller1982Two};',
      '@bib{YOS_9}; ',
      '@bib{RN1333};',
      '@bib{Stol1982State};',
      '@bib{Stol1984Fragment};',
      '@bib{RN1707};',
      '@bib{stol1988oldbabylonian};',
      '@bib{Stol2020reprNABU2020-111};',
      '@bib{stolper1985entrepreneurs}; ',
      '@bib{LS133};',
      '@bib{stolper1991property};',
      '@bib{stolper1993late};',
      '@bib{RN2956};',
      '@bib{Stolper2003No-one};',
      '@bib{Stolper2007Kasr};',
      '@bib{stolper2014neolate};',
      '@bib{stolper2014royal};',
      '@bib{MS22};',
      '@bib{RN1436fg}; ',
      '@bib{RN2702xzz};',
      '@bib{RN2702zzz};',
      '@bib{RN2702xxr};',
      '@bib{RN2702xxy};',
      '@bib{RN2702xxz};',
      '@bib{RN1439};',
      '@bib{RN122rt};',
      '@bib{RN1243}',
    ],
  },
  {
    letter: 'T',
    references: [
      '@bib{RN588};',
      '@bib{tarasewicz2018dubsar};',
      '@bib{tarasewicz2018animal};',
      '@bib{Tenney2017Servile};',
      '@bib{YOS_7};',
      '@bib{Tsukimoto1990New};',
      '@bib{Tulaikov2023Towards}',
    ],
  },
  {
    letter: 'U',
    references: [
      '@bib{VS_3};',
      '@bib{VS_4};',
      '@bib{VS_5};',
      '@bib{VS_6};',
      '@bib{Ungnad1908Leberschau};',
      '@bib{VS_7};',
      '@bib{VS_8};',
      '@bib{VS_9};',
      '@bib{Ungnad1909Neuer};',
      '@bib{PBS_7}',
    ],
  },
  {
    letter: 'V',
    references: [
      '@bib{VanDeMieroop1987Archive};',
      '@bib{BIN_10};',
      '@bib{VanDeMieroop2011Hammurabi};',
      '@bib{RN563};',
      '@bib{VS_26};',
      '@bib{NABU1994-64};',
      '@bib{RN2811};',
      '@bib{RN2750};',
      '@bib{Veldhuis2003Cuneiform};',
      '@bib{RN1343};',
      '@bib{verderame2021fashioning};',
      '@bib{RN3169};',
      '@bib{RN556}; ',
      '@bib{RN556cf};',
      '@bib{RN556a};',
      '@bib{RN556kkxc};',
      '@bib{Visicato2005EarlyDynastic};',
      '@bib{volk2005hymns};',
      '@bib{Volk2023FSMaul}',
    ],
  },
]
